let envTheme = {
    'env': 'local',
    'color-primary': '#A38C3F',
    'color-primary2': '#FF6B35',
    'color-primary-light': '#FFE5DC',
    'color-primary-dark': '#CC4B1F',
    'info': '#3B82F6',
    'warning': '#F59E0B',
    'danger': '#EF4444',
    'form-input-focused-border': '#A38C3F',
    'rbt-border-color-focus-invalid': '#EF4444',
    'rbt-box-shadow-color-valid': '#10B981',
    'btn-trend-gain': '#10B981',
    'btn-trend-loss': '#EF4444',
    'well-bg': '#2D2D2D',
    'color-table-striped': '#2D2D2D',
    'table-cell-border': '#4A4A4A',
    'table-bg-hover': '#3D3D3D',
    'table-bg-selected': '#4A2C1F',
    'alert-info-bg': '#1E3A8A',
    'badge-bg': '#1A1A1A',
    'badge-secondary-outline-border': '#8B8B8B',
    'nav-tabs-hover-bg': '#3D3D3D',
    'nav-text-disabled-color': '#888888',
    'workflow-connector-color': '#666666',
    'pagination-page-link-bg': '#3D3D3D',
    'navbar-disabled-color': '#888888',
    'custom-control-indicator-border-color': '#707070',
    'custom-control-indicator-background': '#1F1F1F',
    'custom-control-description-disabled-text-color': '#6B6B6B',
    'input-background': '#3D3D3D',
    'input-disabled-background': '#2D2D2D',
    'input-group-addon-background': '#2D2D2D',
    'input-group-addon-border': '#5A5A5A',
    'toggle-background': '$color-primary',
};
export default envTheme;